// extracted by mini-css-extract-plugin
export var clearBoth = "image-module--clearBoth--2c0dc";
export var clearLeft = "image-module--clearLeft--160be";
export var clearRight = "image-module--clearRight--194c8";
export var image = "image-module--image--f8080";
export var left = "image-module--left--a7310";
export var right = "image-module--right--671ba";